// extracted by mini-css-extract-plugin
export default {"page":"Solutions_page__z7z7u","filterWrap":"Solutions_filterWrap__W0to8"};